import { LayoutWithSidebar, PageLayout_TwoCol_Narrow_Wide } from "@swivl-mono/ui";
import { Link, Outlet } from "react-router-dom";

import { SidebarLink } from "../../Components/SidebarLink/SidebarLink";

export function AdminView() {
  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          <h1 className="ml-3">Admin</h1>
          <SidebarLink to="/admin/embed">Embed Tester</SidebarLink>

          <SidebarLink to="/admin/server-debug">Server Debug</SidebarLink>
          <SidebarLink to="/admin/variables">Variables</SidebarLink>
          <SidebarLink to="/admin/analytics">Analytics Playground</SidebarLink>
          <SidebarLink to="/admin/onboarding">Onboarding</SidebarLink>
        </div>
      }
      contentNoPadding={true}
      content={<Outlet />}
    />
  );
}
